import * as actionTypes from "../constants/actionTypes";
import * as methods from "../constants/methods";
import * as handlers from "../constants/handlers";

export const addMargin = (name, type, base, colorant) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_ADD_MARGIN,
        params: {
            name: name,
            marginTypeId: type,
            procProducts: base,
            procColorants: colorant
        }
    },
    method: handlers.ADD_MARGIN,
    tabId: 0
});

export const editMargin = (id, name, type, base, colorant, visible) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_EDIT_MARGIN,
        params: {
            id: id,
            name: name,
            marginTypeId: type,
            procProducts: base,
            procColorants: colorant,
            visible: visible
        }
    },
    method: handlers.EDIT_MARGIN,
    tabId: 0
});

export const deleteMargin = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_REMOVE_MARGIN,
        params: {
            id: id
        }
    },
    method: handlers.REMOVE_MARGIN,
    tabId: 0
});

export const moveUpMargin = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MOVE_UP_MARGIN,
        params: {
            id: id
        }
    },
    method: handlers.MOVE_UP_MARGIN,
    tabId: 0
});

export const moveDownMargin = (id) => ({
    type: actionTypes.SERVER_REQUEST,
    payload: {
        type: methods.METHOD_MOVE_DOWN_MARGIN,
        params: {
            id: id
        }
    },
    method: handlers.MOVE_DOWN_MARGIN,
    tabId: 0
});
